module.exports = __webpack_public_path__ + "img/eicon2-2.8b87d545.png";